import {
    isAgentHubAlphaEnabled,
    isAgentHubAlphaOrBetaEnabled,
    isAgentHubBetaEnabled,
    isAgentLibraryEnabled,
} from '@lumapps/agent-hub/ducks/selectors';
import { createSelector } from '@lumapps/redux/reselect';

export const showAgentDrawerButtonSelector = createSelector(
    /** The version in which the button is available */
    isAgentHubAlphaEnabled,
    isAgentHubBetaEnabled,
    (hasAlpha, hasBeta) => hasAlpha || hasBeta,
);

/**
 * Selector to check whether the drawer chat should be rendered
 */
export const showAgentDrawerChatSelector = createSelector(
    /** The version in which the button is available */
    isAgentLibraryEnabled,
    (isCorrectVersionEnabled) => isCorrectVersionEnabled,
);

export const showAgentChatResourcePickerSelector = isAgentHubAlphaOrBetaEnabled;
